import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a8f97a55925773f34ca33fbb9e1abd8c8b from "./generated-6d530f8e-747a-43d6-ab5d-cafb4b16c5ea.json";

import a47bcb4c51bb7566b12f6172c7c5d6d6bb from "./generated-4908edc4-f3ac-441b-9eba-07ec42143e7b.json";

import a543e3a5cb0ece5f72e676cb187dd2131b from "./generated-d0d5ecd3-dd21-4749-bd10-5eef766a0f42.json";

import a24e6bc46fa1261057c72bc6a62e7f9a9b from "./generated-3ea79300-77da-4f05-89d8-0fe65411dda4.json";

import aa987c751bf057aee4629f16bcc778d5fb from "./generated-5902162f-fffd-44a2-8243-b9a5b9b845b9.json";

import a60cf20ed2af9bc5137e5e10a12926628b from "./generated-cd3f3a84-8299-41f8-8a5c-56df616776a8.json";

import ab467755be19bfe5f16e2979b356f8648b from "./generated-fd22243a-fb6c-47c2-a515-32f2be6f157a.json";

import a7913758ef5b6a1cceba60caac77d9184b from "./generated-5670af8b-50d2-45da-9fc3-43cd88876266.json";

import ad62c10574fa3ba3c1f1cbee6d1011689b from "./generated-7e68df80-c0cf-4f11-95cc-d310113afc27.json";

import ab3b6aaf6e164e09147670858b9fc616bb from "./generated-8cbf15f1-6bdf-4269-af24-ab1c436e901f.json";

import a14076bf71eb068dae4958b2f8265955eb from "./generated-231cb624-f4ba-4dc8-8ae8-65a297b659f0.json";

import ae25e13952e03b600ebb843c7f8873eefb from "./generated-da192a56-044d-4032-a63b-d1d6af43fb53.json";

import a7bb20c8a2b010ed4fdcd34debf1fb875b from "./generated-7ab418c8-9dfc-4718-8b15-310c172e7921.json";

import afef756039fa668945d745cc0fc62fb2db from "./generated-c5df2630-0bd0-40ae-b0ec-37d1d43416d2.json";

import a583f75c9fa4bae08ab311341dcc94238b from "./generated-4561dc26-c54a-41d3-b77d-a3a9158bcbcd.json";

import a4d9d50b63f8d852e61de1a72c183b95db from "./generated-306b0010-7b31-42da-a496-3d196e4dea7f.json";

import a0cc0583102f848d456396f649e997c1ab from "./generated-34ddab4c-4746-4868-a8b0-9e35e17fc6f6.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a8f97a55925773f34ca33fbb9e1abd8c8b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a47bcb4c51bb7566b12f6172c7c5d6d6bb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a543e3a5cb0ece5f72e676cb187dd2131b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a24e6bc46fa1261057c72bc6a62e7f9a9b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aa987c751bf057aee4629f16bcc778d5fb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a60cf20ed2af9bc5137e5e10a12926628b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ab467755be19bfe5f16e2979b356f8648b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a7913758ef5b6a1cceba60caac77d9184b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ad62c10574fa3ba3c1f1cbee6d1011689b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ab3b6aaf6e164e09147670858b9fc616bb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a14076bf71eb068dae4958b2f8265955eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ae25e13952e03b600ebb843c7f8873eefb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ad62c10574fa3ba3c1f1cbee6d1011689b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a7bb20c8a2b010ed4fdcd34debf1fb875b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(afef756039fa668945d745cc0fc62fb2db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ad62c10574fa3ba3c1f1cbee6d1011689b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a583f75c9fa4bae08ab311341dcc94238b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a4d9d50b63f8d852e61de1a72c183b95db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a0cc0583102f848d456396f649e997c1ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a583f75c9fa4bae08ab311341dcc94238b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */